import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export class RadioInput extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        className: PropTypes.string,
        onClick: PropTypes.func,
        // Provided by Field HOC
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        radioValue: PropTypes.string.isRequired,
        radioLabel: PropTypes.string.isRequired,
        radioChoice: PropTypes.string,
    };

    static defaultProps = {
        className: ''
    };

    render() {
        const {
            id,
            input,
            meta: { submitFailed },
            className,
            onClick,
            radioValue,
            radioLabel,
            radioChoice
        } = this.props;

        const inputName = input.name || id;
        let errorInputAttributes = {};
        if (submitFailed) {
            errorInputAttributes = {
                'aria-describedby': 'radio_error-message'
            };
        }

        return (
            <div className="ppvx_radio">
                <input
                    {...input}
                    className="radioInput ppvx_radio__input"
                    type="radio"
                    id={id}
                    name={inputName}
                    value={radioValue}
                    checked={radioChoice === radioValue}
                    aria-checked={radioChoice === radioValue}
                    {...errorInputAttributes}
                />
                <label 
                    htmlFor={id} 
                    className="ppvx_radio__label radioLabel"
                >
                    {radioLabel}
                </label>
            </div>
        );
    }
}

export default RadioInput;
